<template>
  <div id="inventarList">
    <div class="inventar">
      <ul v-for="item in userInventar" :key="item.id">
         <li>
           <img :data-desc='item.title' :src="item.img" @mouseover='selectedText=item.description' @mouseout='selectedText=" "' />
           <div class="hoverbox"> {{ showItemContent }} </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  name: 'inventarList',
  props: ['currentRoomData'],
  data() {
    return {
      selectedText:" "
    }
  },
  computed:{
    ...mapGetters({
       userInventar: 'getInventar'
    }),
    showItemContent(){
      return this.selectedText
    }
  }

}
</script>
<style lang="scss" scoped>
.inventar{
    position: relative;
  .hoverbox{
    position: absolute;
    left: 50%;
    top: 150%;
    transform: translate(-50%, -150%);
    visibility: hidden;
    pointer-events: none;
    padding: 1rem;
    display: block;
    z-index: 100;
    position: absolute;
    min-height: 3rem;
    background: black;
    border: solid 5px magenta;
  }
  ul{
    padding: 0;
    margin:0;
    li{
      padding:5px;
      list-style: none;
      float: left;
      border:solid 1px black;
      span{
        display: block;
      }
      img{
        width:50px;
        height: auto;
        background: white;
        position: relative;
        &:hover  {
            + .hoverbox{
              visibility: visible;
            }
        }
      }
    }
  }
}
</style>
